import { createApi, createStore } from "effector"

export const $wsStatus = createStore("closed")

export const { open, closed, error } = createApi($wsStatus, {
  open: () => "open",
  closed: () => "closed",
  error: () => "error",
})
